import React, { useState, useEffect, useContext ,useCallback} from 'react'
import Table from "components/Table/Table";
import UserDetailsAPI from 'apis/userDetails/UserDetails';
import Context from 'context/context';
import searchIcon from "assets/img/Search_Icon.png";

import { toast } from "react-toastify";
import { CSVLink } from 'react-csv';
import * as moment from "moment";
import useDebounce from "helpers/useDebounce";
import HistoryTable from "components/Table/History/HistoryTable";
import Loader from "components/Loader/Loader";


import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Slide from "@material-ui/core/Slide";
import Button from "@material-ui/core/Button";
import { MenuItem } from '@material-ui/core'
import { useTranslation } from 'react-i18next';
import { exportHeaders } from "./export";

// material-ui icons
import Grid from "@material-ui/core/Grid";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import { blockInvalidCharForText } from 'helpers/blockInvalidCharForText';
import { styles } from './styles'
import editIcon from 'assets/img/editIcon.png';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import RemoveRedEyeIcon from "@material-ui/icons/RemoveRedEye";
import HistoryIcon from "@material-ui/icons/History";
import access from "config/access";
import audit from "apis/audit/audit";



// custom TextField
const CssTextField = withStyles({
    root: {
        "& label.Mui-focused": {
            color: "##D3D3D3",
        },
        "& .MuiFormLabel-root": {
            color: "#707070",
        },
        "& .MuiInputBase-input": {
            color: "#707070",
        },
        "& .MuiInput-underline:before": {
            borderBottomColor: "#707070!important",
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: "#707070!important",
        },
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                borderColor: "#707070",
            },
            "&:hover fieldset": {
                borderColor: "#707070",
            },
            "&.Mui-focused fieldset": {
                borderColor: "#707070",
            },
            "&.MuiOutlinedInput-root": {
                borderRadius: 20,
            },
            "&.MuiOutlinedInput-root": {
                marginTop: 0,
                borderRadius: 20,
                background: "#ededed",
            },
        },
    },
})(TextField);

const sendEmailTransition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

function OnewebRestricted() {
    const { handleCanadaOnewebRestrictedShipto } = UserDetailsAPI()
    const { state, dispatch } = useContext(Context)
    const classes = styles();
    const [data, setData] = useState([])
    const [offset, setOffset] = useState(1);
    const [count, setCount] = useState(0);
    const [loading, setLoading] = useState(true)
    const [isLoading, setIsLoading] = useState(false);
    const { t, i18n } = useTranslation()
    const [exportData, setExportData] = useState([]);
    const [states, setstates] = useState({
        historyLoader: false,
    });

    const [searchValue, setSearchValue] = useState("")
    const [createObj, setCreateObj] = useState({
        
        customer_billto_account_number: '',
        is_active: '',
        type: 'CREATE'
    });
    const [editObj, setEditObj] = useState({
        customer_billto_account_number: '',
        is_active: '',
        type: 'UPDATE'
    });
    const [popupOpen, setPopupOpen] = useState(false);
    const searchBounceValues = useDebounce(searchValue);
    const { historyLoader } = states;
    const setStates = useCallback((newState) => {
        setstates((states) => ({ ...states, ...newState }));
      }, []);
  const { getAudit } = audit();


    useEffect(() => {
        if (searchBounceValues && searchBounceValues.length > 0) {
            handleSearch()
        } else {
            getUserDetails()
        }
    }, [searchBounceValues, offset])


    useEffect(() => {
        dispatch({
            type: "SET_PATHNAME",
            payload: ["HOME", "ADMIN", "Oneweb Restricted"],
        });
    }, []);

    async function getUserDetails() {
        try {
            setLoading(true)
            let values;
            values = {
                offset: (offset - 1) * 10,
                limit: 10,
                type: "GET"
            };

            dispatch({ type: "SET_LOADING", payload: true });
            let res = await handleCanadaOnewebRestrictedShipto(values);
            if (res) {
                setData(res.data);
                setCount(res.count);
                setLoading(false)
                dispatch({ type: "SET_LOADING", payload: false });
            }
        } catch (e) {
            console.log({ e });
        }
    }

    async function handleSearch() {
        try {
            setLoading(true)
            let values;
            values = {
                searchValue,
                offset: (offset - 1) * 10,
                limit: 10,
                type: "SEARCH"
            };
            setEditObj({
                customer_billto_account_number: '',
                is_active: '',
                type: 'UPDATE'
            })
            dispatch({ type: "SET_LOADING", payload: true });
            let res = await handleCanadaOnewebRestrictedShipto(values);
            if (res) {
                setData(res.data);
                setCount(res.count);
                setLoading(false)
                dispatch({ type: "SET_LOADING", payload: false });
            }
        } catch (e) {
            console.log({ e });
        }
    }

    async function handleCreate() {
        try {
            const { customer_billto_account_number, is_active } = createObj;
            if (!(typeof is_active === 'boolean' || !customer_billto_account_number)) {
                return toast.error('Please fill all the fields');
            }
            setLoading(true);
            let obj = { ...createObj, type: 'CREATE' }
            dispatch({ type: "SET_LOADING", payload: true });
            let res = await handleCanadaOnewebRestrictedShipto(obj);
            if (res.type == 'success') {
                setLoading(false)
                dispatch({ type: "SET_LOADING", payload: false });
                toast.success(res.message)
                setPopupOpen(false)
                setCreateObj({
                   
                    customer_billto_account_number: '',
                    is_active: '',
                    type: 'CREATE'
                })
                // setEditObj({})
                getUserDetails();
            } else {
                setLoading(false)
                dispatch({ type: "SET_LOADING", payload: false });
                toast.error(res.message)
            }
        } catch (e) {
            console.log({ e });
        }
    }

    async function handleUpdate() {
        try {
            setLoading(true);
            dispatch({ type: "SET_LOADING", payload: true });
            let obj = { ...editObj, type: 'UPDATE' }
            // setEditObj({...editObj,type:'UPDATE'})
            let res = await handleCanadaOnewebRestrictedShipto(obj);
            if (res.type == 'success') {
                setLoading(false)
                dispatch({ type: "SET_LOADING", payload: false });
                toast.success(res.message)
                setEditObj({})
                getUserDetails()
            } else {
                setLoading(false)
                dispatch({ type: "SET_LOADING", payload: false });
                toast.error(res.message)
                getUserDetails()
            }
        } catch (e) {
            console.log({ e });
        }
    }


    let tableHeading = [
      
       "Billto ID",
        "Access",
         "",
         state?.userInfo?.auditAccess? "History":"",
    ];

    const handleExport = async () => {
        // let values = {};
        if (searchValue) {
          values = { ...values, searchValue };
        }
        // setLoading(true)
        let values;
        values = {
            searchValue,
  
            type: "EXPORT"
        };

        dispatch({ type: "SET_LOADING", payload: true });
        let res = await handleCanadaOnewebRestrictedShipto(values);
        if (res && res.data) {
            // setIsLoading(false);
            setExportData(res.data);
            dispatch({ type: "SET_LOADING", payload: false });
           
            if (res.data.length === 0) {
              toast.success(t("No Data Found"), { toastId: "no-report-date" });
              return false;
            }
           
            return true;
          }
        }

        const handleGetHistoryData = async (id) => {
            try {
              let values;
              values = {
                recordId: id,
                key: "restrictedbilto",
              };
              let res = await getAudit(values);
              if (res) {
                setStates({ historyData: res?.data, historyLoader: false });
              }
            } catch (e) {
              console.log({ e });
            }
          };
        
    
      
       
      

    const handlePagination = (value) => {
        setOffset(value);
    };

    return (
        <div>
            {/* <h2>Oneweb Restricted Shipto</h2> */}
            <Grid xs={12} sm={12} lg={12} className={classes.topGrid}>
                <Grid>
                    <CssTextField
                        id="enterPassword"
                        placeholder={'Search for Billto'}
                        onKeyDown={blockInvalidCharForText}
                        type={"text"}
                        variant="outlined"
                        autoComplete="off"
                        className={classes.searchInput}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    {searchValue.length > 0 ? (
                                        <CloseOutlinedIcon
                                            className={classes.searchInputIcon}
                                            onClick={() => {
                                                setSearchValue("");
                                                setOffset(1);
                                                getUserDetails();
                                            }}
                                        />
                                    ) : (
                                        <img
                                            src={searchIcon}
                                            alt=""
                                            width="20px"
                                            className={classes.searchInputIcon}
                                        />
                                    )}
                                </InputAdornment>
                            ),
                        }}
                        value={searchValue}
                        onChange={(e) => {
                            e.target.value.replace(/\s+/g, "").length == 0
                                ? setSearchValue("")
                                : setSearchValue(e.target.value);
                            if (e.target.value.length == 0) {
                                getUserDetails();
                            }
                        }}
                        onClick={() => {
                            setOffset(1);
                        }}
                    />
                    <Button
                        className={`${classes.createBtn} dash-1-filter-btn`}
                        onClick={() => {
                            setPopupOpen(true)
                            setCreateObj({
                              
                                customer_billto_account_number: '',
                                is_active: '',
                                type: 'CREATE'
                            })
                        }}
                    >
                        {'Create'}
                    </Button>
                </Grid>

                <CSVLink
            id="csv"
            data={exportData.map(item => ({
                ...item,
                is_active: item.is_active ? "Restricted" : "Not Restricted"
              }))}
             headers={exportHeaders}
         filename={
              `Restricted-Billto` +
              " " +
              moment(new Date()).format("MM-DD-YYYY,h:mm A") +
              ".csv"
            }
            className={classes.CSVlink}
          />
                <button
            disabled={isLoading}
            className={classes.exportBtn1}
            onClick={async () => {
              let res = await handleExport();
              if (res) {
                document.getElementById("csv").click();
              }
            }}
          >
            {t('Export')}
          </button>
            </Grid>
            <div style={{ marginTop: 20 }}>
                {!loading ? <Table
                    headings={tableHeading.map((i) => {
                        return <div key={i}>{i}</div>
                    })}
                    data={data &&
                        data.length > 0 &&
                        data.map((p,i) => [
                            // [p?.id],
                           
                            [p?.customer_billto_account_number],
                            editObj?.customer_billto_account_number == p?.customer_billto_account_number ?
                                <TextField
                                    select
                                    value={editObj?.is_active}
                                    onChange={e => setEditObj({ ...editObj, is_active: e.target.value })}
                                    style={{ width: "100%" }}
                                >
                                    <MenuItem value={true}>Restricted</MenuItem>
                                    <MenuItem value={false}>Not Restricted</MenuItem>
                                </TextField> :
                                [p?.is_active == true ?
                                    <span style={{ color: "red" }}>Restricted</span> :
                                    <span style={{ color: "green" }}>Not Restricted</span>
                                ],

                                // [
                                //     <RemoveRedEyeIcon
                                //     //   key={i}
                                //       style={{ cursor: "pointer" }}
                                //     //   onClick={() => {
                                //     //     history.push("/dashboard/contract-code-details", {
                                //     //       mpcId: p?.shipto,
                                //     //       offset,
                                //     //     });
                                //     //   }}
                                //     />,
                                //   ],
                                 
                               
                            [
                                editObj.customer_billto_account_number == p?.customer_billto_account_number ? (
                                    <React.Fragment>
                                        <CheckCircleOutlineIcon
                                            style={{
                                                cursor: 'pointer',
                                                color: 'green',
                                                margin: '0px 5px',
                                                fontSize: 35,
                                            }}
                                            onClick={() => {
                                                if (editObj.is_active === p?.is_active) {
                                                    toast.success("change any field");
                                                    return;

                                                }

                                                handleUpdate();
                                            }}
                                        />
                                        <HighlightOffIcon
                                            style={{
                                                cursor: 'pointer',
                                                color: 'red',
                                                margin: '0px 5px',
                                                fontSize: 35,
                                            }}
                                            onClick={() => {

                                                setEditObj({});

                                            }}
                                        />
                                    </React.Fragment>
                                ) : (
                                    (
                                        <div
                                            style={{ cursor: 'pointer' }}

                                            onClick={() => {

                                                setEditObj({ ...editObj, customer_billto_account_number: p?.customer_billto_account_number, is_active: p?.is_active })



                                                return;
                                            }
                                            }
                                        >
                                            <img src={editIcon} alt='' width='20' />
                                        </div>
                                    )
                                ),
                            ],
                            state?.userInfo?.auditAccess && (
                                <HistoryIcon
                                   key={i}
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    setStates({
                                      historyDialog: true,
                                      historyLoader: true,
                                    });
                                    handleGetHistoryData(p?.customer_billto_account_number);
                                  }}
                                />
                              ),

                        ])}
                    offset={offset}
                    count={
                        (count / 10) % 1 == 0
                            ? Math.floor(count / 10)
                            : Math.floor(count / 10 + 1)
                    }
                    handlePagination={handlePagination}
                /> :
                    <div style={{ height: '25vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <h2>Loading...</h2>
                    </div>}
            </div>
            <Dialog
        aria-labelledby="simple-dialog-title"
        open={states.historyDialog ? true : false}
        style={{ fontFamily: "Segoe-ui" }}
        maxWidth={false}
      >
        <div className={classes.dialogParentDiv}>
          <div
            className={classes.parentText}
            style={{
              paddingBottom: 10,
              width: states?.historyData?.length > 0 ? "100%" : 300,
            }}
          >
            {t('History')}
            <span style={{ float: "right" }}>
              <HighlightOffIcon
                style={{
                  cursor: "pointer",
                  color: "red",
                  fontSize: 35,
                }}
                onClick={() => {
                  setStates({ historyDialog: false, historyData: [] });
                }}
              />
            </span>
          </div>

          {!historyLoader ? (
            <HistoryTable
              headings={[
                "Date of Change",
                "Updated by",
                "Column Name",
                "Description",
              ]}
              data={
                states?.historyData?.length > 0 &&
                states?.historyData.map((d, i) => [
                  d?.created_at
                    ? `${moment(d?.created_at).format("YYYY-MM-DD HH:mm:ss")}`
                    : "",
                  `${d?.["User.email"]
                    ? d?.["User.email"]
                    : d?.altered_by
                      ? d?.altered_by.charAt(0).toUpperCase() +
                      d?.altered_by.slice(1).toLowerCase()
                      : "-"
                  }`,
                  d?.column_name,
                  `"${d?.old_value}" changed to "${d?.new_value}"`,
                ])
              }
              disablePagination={true}
            />
          ) : (
            <div>
              <Loader Loading={historyLoader} top={"15%"}></Loader>
            </div>
          )}
        </div>
      </Dialog>
            <Dialog
                open={popupOpen == true}
                TransitionComponent={sendEmailTransition}
                keepMounted
                onClose={() => setPopupOpen(false)}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogContent>
                    <div
                        style={{
                            fontSize: 20,
                            fontWeight: 'bold',
                            textAlign: 'center',
                        }}
                    >
                        {'Create New Billto'}
                    </div>
                    <CloseOutlinedIcon
                        className={classes.closeIcon}
                        onClick={() => {
                            setPopupOpen(false)
                            setCreateObj({})
                        }}
                    />
                   
                    <TextField
                        id="billto"
                        placeholder={'Enter Billto'}
                        label={'Billto'}
                        type={"text"}
                        style={{ margin: 10, width: '90%' }}
                        variant="outlined"
                        autoComplete="off"
                        value={createObj?.customer_billto_account_number}
                        onChange={(e) => {
                            setCreateObj({ ...createObj, customer_billto_account_number: e.target.value })
                        }}
                    />
                    <TextField
                        id="type"
                        placeholder={'Access'}
                        label={'Access'}
                        select
                        style={{ margin: 10, width: '90%' }}
                        variant="outlined"
                        autoComplete="off"
                        value={createObj.is_active}
                        onChange={(e) => {
                            setCreateObj({ ...createObj, is_active: e.target.value })
                        }}
                    >
                        <MenuItem value={true}>Restricted</MenuItem>
                        <MenuItem value={false}>Not Restricted</MenuItem>
                    </TextField>
                    <Button
                        className={classes.createBtn}
                        disabled={ !createObj?.customer_billto_account_number || typeof createObj?.is_active != 'boolean'}
                        style={( !createObj?.customer_billto_account_number || typeof createObj?.is_active != 'boolean') ?
                            { width: 120, marginLeft: '40%', background: 'grey' } : { width: 120, marginLeft: '40%' }}
                        onClick={handleCreate}
                    >
                        {'Create'}
                    </Button>
                </DialogContent>
            </Dialog>
        </div>
    )
}

export default OnewebRestricted;